export const userRoles = Object.freeze({
  ADMIN: "admin",
  DEBUG: "debug",
  TECHNICIAN: "technician",
})

export const apiAccessRoles = Object.freeze({
  FULL: "full",
  TWO_FA: "two-fa",
})

export const isFullScope = (scope = []) => scope.includes(apiAccessRoles.FULL)

export const isTwoFaScope = (scope = []) =>
  scope.includes(apiAccessRoles.TWO_FA)

export const tableViews = Object.freeze({
  BASIC: "basic",
  EXTENDED: "extended",
})

export const bodyParts = Object.freeze({
  SPINE: "Spine",
  BRAIN: "Brain",
  KNEE: "Knee",
  SHOULDER: "Shoulder",
})

export const logsSource = Object.freeze({
  RAMSOFT: "RAMSOFT",
  OUTSIDE_V3: "OUTSIDE V3",
})

export const dbDateTimeFormat = "yyyy-MM-dd HH:mm:ss.SSS"

export const dbDateFormat = "yyyy-MM-dd"
